import { Email, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { getTitleTranslationKey, guardString } from "@msuite/utils/strings";
import type { ContactMember } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ContactMember>();

export const columns = [
	columnHelper.accessor("title", {
		id: "title",
		header: localized("profile.title"),
		cell: (info) => localized(getTitleTranslationKey(guardString(info.getValue()))),
	}),
	columnHelper.accessor("contactId", {
		header: "contactId",
	}),
	columnHelper.accessor("_contact.name", {
		id: "contactName",
		header: localized("contacts.contact"),
	}),
	columnHelper.accessor("firstName", {
		header: localized("profile.first_name"),
		cell: (cell) => {
			const ov = cell.row.original._memberOverride?.overrides as Record<string, unknown> | null;
			return guardString((ov?.firstName as string | null) ?? cell.getValue());
		},
	}),
	columnHelper.accessor("lastName", {
		header: localized("profile.last_name"),
		cell: (cell) => {
			const ov = cell.row.original._memberOverride?.overrides as Record<string, unknown> | null;
			return guardString((ov?.lastName as string | null) ?? cell.getValue());
		},
	}),
	columnHelper.accessor("email", {
		header: localized("personnel.fields.email"),
		cell: (cell) => {
			const ov = cell.row.original._memberOverride?.overrides as Record<string, unknown> | null;
			return <Email>{guardString((ov?.email as string | null) ?? cell.getValue())}</Email>;
		},
	}),
	columnHelper.accessor("phone", {
		header: localized("personnel.fields.phone"),
		cell: (cell) => {
			const ov = cell.row.original._memberOverride?.overrides as Record<string, unknown> | null;
			return <Phone>{guardString((ov?.phone as string | null) ?? cell.getValue())}</Phone>;
		},
	}),
	columnHelper.accessor("_type.name", {
		header: localized("general.type"),
		cell: (cell) =>
			cell.row.original._type ? (
				<Tag
					variant="plain"
					color={cell.row.original._type.color}
				>
					{guardString(cell.getValue())}
				</Tag>
			) : (
				guardString(null)
			),
	}),
	columnHelper.accessor((row) => row._authorizations.map((auth) => auth._type.name), {
		id: "contact_member_authorizations",
		header: localized("contacts.member_authorizations"),
		cell: (cell) => cell.getValue(),
	}),
	createRowActions(RowActions),
];
